<div class="upload-file-summary">
  <div class="upload-file-summary__header">{{ 'upload_file_summary.SuccessfulRowsUploaded' | translate }}</div>
  <div class="upload-file-summary__rows-container">
    <ion-row class="upload-file-summary__row-header">
      <ion-col>
        <div>{{ 'upload_file_summary.TotalProcessed' | translate }}</div>
      </ion-col>
      <ion-col>
        <div>{{ summary.totalProcessedRows }} {{ 'upload_file_summary.Rows' | translate }}</div>
      </ion-col>
    </ion-row>
    <ion-row class="upload-file-summary__successful-row">
      <ion-col>
        <div>
          <img class="upload-file-summary__status-icon" src="assets/common/tick-green.svg" />
          <span>{{ 'upload_file_summary.Successful' | translate }}</span>
        </div>
      </ion-col>
      <ion-col>
        <div>{{ summary.successfulRows }} {{ 'upload_file_summary.Rows' | translate }}</div>
      </ion-col>
    </ion-row>
    <ion-row class="upload-file-summary__failure-row">
      <ion-col>
        <div>
          <img class="upload-file-summary__status-icon" src="assets/common/error-icon.svg" />
          <span>{{ 'upload_file_summary.Failed' | translate }}</span>
        </div>
      </ion-col>
      <ion-col>
        <div>
          {{ summary.failedRows }} {{ 'upload_file_summary.Rows' | translate }}, {{ summary.errors }}
          {{ 'upload_file_summary.Errors' | translate }}
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="upload-file-summary__error-container">
      <ion-col size="12" class="upload-file-summary__error-container-header">
        {{ 'upload_file_summary.Howtofixfailedrows?' | translate }}
      </ion-col>
      <ion-col>{{ 'upload_file_summary.Downloaderrorfile' | translate }}</ion-col>
      <ion-col>
        <img class="upload-file-summary__error-container-arrow" src="assets/common/right-arrow-grey.svg" />
      </ion-col>
      <ion-col>{{ 'upload_file_summary.OpeninExcel' | translate }}</ion-col>
      <ion-col>
        <img class="upload-file-summary__error-container-arrow" src="assets/common/right-arrow-grey.svg" />
      </ion-col>
      <ion-col>{{ 'upload_file_summary.Fixallerrors' | translate }}</ion-col>
      <ion-col>
        <img class="upload-file-summary__error-container-arrow" src="assets/common/right-arrow-grey.svg" />
      </ion-col>
      <ion-col>{{ 'upload_file_summary.Uploadcorrectedfile' | translate }}</ion-col>
    </ion-row>
    <ion-row *ngIf="summary.errorMessageOpt">
      <div class="upload-file-summary__error-msg">
        {{ 'upload_file_summary.Error' | translate }}: {{ summary.errorMessageOpt }}
      </div>
    </ion-row>
    <ion-row *ngIf="summary.errorFileKeyOpt" class="upload-file-summary__btn-row">
      <ui-custom-button
        [btnTxt]="'upload_file_summary.Downloaderrorfileandexit' | translate"
        [buttonType]="'PRIMARY'"
        (clickEvent)="onDownloadErrorFile()"
      ></ui-custom-button>
    </ion-row>
  </div>
</div>
